import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
    options: {
        customProperties: true
    }
})

const opts = {
    theme: {
        themes: {
            light: {
                primary: getComputedStyle(document.body).getPropertyValue('--color-primary') ? getComputedStyle(document.body).getPropertyValue('--color-primary').trim() : '#003371',
                primaryHover: getComputedStyle(document.body).getPropertyValue('--color-primary-hover') ? getComputedStyle(document.body).getPropertyValue('--color-primary-hover').trim() : '#004CA3',
                primaryLighter: getComputedStyle(document.body).getPropertyValue('--color-primary') ? getComputedStyle(document.body).getPropertyValue('--color-primary').trim() : '#003371',
                secondary: '#5598db',
                accent: '#edae44'
            },
        },
    },
}

export default new Vuetify(opts)
